import { render, staticRenderFns } from "./PriceOption.vue?vue&type=template&id=4d60d0e6"
import script from "./PriceOption.vue?vue&type=script&lang=js"
export * from "./PriceOption.vue?vue&type=script&lang=js"
import style0 from "./PriceOption.vue?vue&type=style&index=0&id=4d60d0e6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d60d0e6')) {
      api.createRecord('4d60d0e6', component.options)
    } else {
      api.reload('4d60d0e6', component.options)
    }
    module.hot.accept("./PriceOption.vue?vue&type=template&id=4d60d0e6", function () {
      api.rerender('4d60d0e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/price/PriceOption.vue"
export default component.exports